<template>
    <div>
        <div>
            <div v-if="!is_editing">
                <day :day="day"></day>
            </div>

            <div class="edit-itinerary-item__form-wrapper" v-else>
                <b-form @submit.prevent="onSubmit()">
                    <b-form-group>
                        <label>
                            Date
                        </label>

                        <date-picker 
                            :datestring="form.date" 
                            :config="datepickers.date_config"
                            @changed="(new_date) => {
                                form.date = new_date;
                            }">
                        </date-picker>

                        <label>
                            Start Time
                        </label>

                        <date-picker 
                            :datestring="form.start_time" 
                            :config="datepickers.time_config"
                            @changed="(new_time) => {
                                form.start_time = new_time;
                            }">
                        </date-picker>

                        <label>
                            End Time
                        </label>
                        
                        <date-picker 
                            :datestring="form.end_time" 
                            :config="datepickers.time_config"
                            @changed="(new_time) => {
                                form.end_time = new_time;
                            }">
                        </date-picker>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        Submit
                    </b-button>
                </b-form>
            </div>

            <div class="text-right">
                <a href="#" class="text-primary font-weight-bold mr-2" @click.prevent="toggleEdit">
                    {{ !is_editing ? "Edit" : "Cancel editing" }}
                </a>

                <a href="#" class="text-danger font-weight-bold" @click.prevent="askDeleteItem">
                    Delete
                </a>
            </div>
        </div>

        <b-modal 
            v-model="show_delete_modal"
            id="delete-modal"
            title="Warning"
            @ok="deleteItem()"
            header-bg-variant="danger"
            header-text-variant="light"
            ok-title="Delete"
            ok-variant="danger">
            Are you sure you want to permanently delete this itinerary item?
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import Day from '@/components/Day.vue';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_DATE_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['day'],

        components: {
            DatePicker,
            Day
        },
        
        data() {
            return {
                is_editing: false,
                show_delete_modal: false,

                datepickers: {
                    date_config: {
                        format: SERVER_DATE_FORMAT,
                        display_format: LOCAL_DATE_FORMAT
                    },

                    time_config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },

        computed: {
            form() {
                return {
                    ...this.day
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('changed', { ...this.form });
                this.is_editing = false;
            },

            toggleEdit() {
                this.is_editing = !this.is_editing;
            },

            askDeleteItem() {
                this.show_delete_modal = true;
            },
            
            deleteItem() {
                this.$emit('deleted', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    form {
        margin-bottom: 10px;
    }

    .form-group {
        margin-bottom: 0;
    }

    .alert {
        margin-top: 5px;
    }

    textarea {
        margin-bottom: 10px;
    }
    
    .day__title {

    }

    .edit-itinerary-item__form-wrapper {
        
    }
</style>